import { SxProps } from "@mui/system"
import React from "react"
import { useEffect, useState } from "react"

import { DGText } from "../../../components/common/DGText"
import { Time } from "../../../components/common/LiveConcertTime"
import { LiveConcertExtract } from "../../../components/Sliders/Slider"
import { LiveConcertRerunFieldsFragment } from "../../../generated/graphql"
import useIntl from "../../../hooks/use-intl"
import useLiveConcertState from "../../../hooks/use-live-concert-state"
import useTranslate from "../../../hooks/use-translate"
import { theme, TI } from "../../../utilities/theme"

type LiveConcertRerunListProps = {
  liveConcert: Pick<
    LiveConcertExtract,
    "endTime" | "startTime" | "streamStartTime" | "reruns"
  >
  sx?: SxProps
  tx?: TI
  singleLine?: boolean
  isTeaser?: boolean
}

export const Reruns = ({
  liveConcert,
  sx,
  tx,
  singleLine = false,
  isTeaser = false,
}: LiveConcertRerunListProps) => {
  const { upcomingReruns } = useLiveConcertState(liveConcert)
  const t = useTranslate()
  const [reruns, setReruns] = useState<LiveConcertRerunFieldsFragment[]>([])
  const { dateFormat } = useIntl()

  useEffect(() => {
    setReruns(
      singleLine && upcomingReruns.length > 0
        ? [upcomingReruns[0]]
        : upcomingReruns,
    )
  }, [upcomingReruns])

  return (
    <>
      {reruns.length === 0
        ? null
        : reruns.map((rerun, index) => (
            <DGText
              tx={tx ?? TI.Subheadline02tv}
              key={rerun.startTime}
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
                color: theme.palette.white[55],
                ...sx,
              }}
            >
              {singleLine || isTeaser ? (
                <span>
                  {t("component__rerun_next_label", [
                    dateFormat(new Date(rerun.startTime), "shortTime"),
                  ])}
                </span>
              ) : (
                <>
                  <span>
                    {`${index + 1}. ${t("component__rerun_default_label")}`}
                    &nbsp;&ndash;&nbsp;
                  </span>
                  <Time value={rerun.startTime} style="shortTime" />
                </>
              )}
            </DGText>
          ))}
    </>
  )
}
